import { fetchCitiesFromContentful, fetchCityFromContentful } from '@src/api/contentful-api';
import { City } from '@src/model';

export const fetchCity = (citySlug: string): Promise<City> => fetchCityFromContentful(citySlug);

export const fetchCities = (): Promise<City[]> => fetchCitiesFromContentful();
